var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('button',{on:{"click":function($event){_vm.show = true}}},[_vm._v("更换头像")]),_vm._v(" "),_c('avatar-cropper',{on:{"ok":function($event){_vm.data = $event}},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}}),_vm._v(" "),_c('img',{staticStyle:{"display":"block"},attrs:{"src":_vm.data}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed12c06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 